export const SENTRY_RELEASE: string | undefined = 'ea02ad606b0277ba0d3006ca94884597abdd4ecf';
